export class CaseTypeSpecification {
  caseType: string | undefined;
  boardMaterialOptionId: string | undefined;
  caseMaterialOptionId: string | undefined;
  casePaper: string | undefined;
  spineStampingOptionId: string | undefined;
  spineStampingOptionValue: number | undefined;
  foil: string | undefined;
  frontBackStamping: string | undefined;
  frontBackPanelFoil: string | undefined;
  finishing: string | undefined;
  specialEffects: string | undefined;
  printOverFoil: string | undefined;

  constructor() {
    this.caseType = undefined;
    this.boardMaterialOptionId = undefined;
    this.caseMaterialOptionId = undefined;
    this.casePaper = undefined;
    this.spineStampingOptionId = undefined;
    this.spineStampingOptionValue = undefined;
    this.foil = undefined;
    this.frontBackStamping = undefined;
    this.frontBackPanelFoil = undefined;
    this.finishing = undefined;
    this.specialEffects = undefined;
    this.printOverFoil = undefined;
  }
}
